/*jshint esversion: 6 */

jQuery(function(){

	jQuery('body').on('click', '.account-edit-card__edit-link', function(e){

		e.preventDefault();

		var $this = jQuery(this);

		var $parents = $this.parents('.account-edit-card__section');

		$parents.find('.account-edit-card__save-message').remove();

		$this.addClass('account-edit-card__edit-link--disabled');

		$parents.find('.account-edit-card__section-details').addClass('account-edit-card__section-details--hidden');
		$parents.find('.account-edit-card__section-form').removeClass('account-edit-card__section-form--hidden');
		if ($parents.find('.edit__address-lookup--street-no').length>0 && $parents.find('.edit__address-lookup--street-no').hasClass('no-update-on-lookup')==false)
		{
			$parents.find('.input__address-lookup--street-no').addClass('no-update-on-lookup');
		}
		
		return false;
	});

	jQuery('body').on('click', '.account-edit-card__link--form-cancel', function(e){

		e.preventDefault();

		var $this = jQuery(this);

		var $parents = $this.parents('.account-edit-card__section');

		$parents.find('.account-edit-card__edit-link--disabled').removeClass('account-edit-card__edit-link--disabled');

		$parents.find('.account-edit-card__section-details').removeClass('account-edit-card__section-details--hidden');
		$parents.find('.account-edit-card__section-form').addClass('account-edit-card__section-form--hidden');

		return false;
	});

	if(jQuery('.form--no-submit').length > 0) {

		jQuery('.form--no-submit').each(function(index, form){

			jQuery(form).on('submit', function(e){

				e.preventDefault();

				var $this = jQuery(this);

				var $parents = $this.parents('.account-edit-card__section');

				var $errors = $this.find('.parsley-error');

				if ($errors.length > 0) {
					//console.log('there is a problem!');
				} else {

					// Update the values of the read-only form
					var $inputs = $parents.find('input').toArray();
					var $selects = $parents.find('select').toArray();

					jQuery.each($inputs, function(index, input) {
						var findValue = input.id;
						var update = jQuery('[data-input='+findValue+']');

						if (!input.value) {
							update.text('-');
						} else {
							update.text(input.value);
						}
					});

					jQuery.each($selects, function(index, input) {
						var findValue = input.id;
						var update = jQuery('[data-input=' + findValue + ']');

						update.text(input.value);
					});

					// Return form section to initial state
					$parents.find('.account-edit-card__edit-link--disabled').removeClass('account-edit-card__edit-link--disabled');
					$parents.find('.account-edit-card__section-details').removeClass('account-edit-card__section-details--hidden');
					$parents.find('.account-edit-card__section-form').addClass('account-edit-card__section-form--hidden');

					// HTML to append
					var circleCheck = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polyline fill="none" stroke="#0E772D" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="17,8.5 9.5,15.5 7,13 "/><circle fill="none" stroke="#0E772D" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="12" cy="12" r="11.5"/></g></g><g id="New_icons_1_"></g></g></svg>';

					var saved = '<div class="row account-edit-card__save-message"><div class="col-sm-10 col-sm-offset-1"><div class="account-edit-card__save-message--saved">' + circleCheck + ' Changes Saved </div></div></div>';

					$parents.append(saved);

				}


				return false;
			});

		});
	}

});